import { KeyIcon, ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { ArrowRightIcon } from "@heroicons/react/20/solid";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { StateGeneral, resetActivate } from "lib/actions";
import { resSuccessful } from "lib/utils";
import Modal from "react-modal";

export default function FormActivate() {
  const navigate = useNavigate();

  interface formDataType {
    [key: string]: FormDataEntryValue;
  }
  const responseBody: formDataType = {};

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const passSalt = searchParams.get("salt") || "";

  const [responseData, setResponseData] = useState<StateGeneral>();
  const [btnSubmitDisabled, setBtnSubmitDisabled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  async function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    const formData = new FormData(event.currentTarget as HTMLFormElement);
    formData.forEach(
      (value, property: string) => (responseBody[property] = value),
    );
    try {
      setBtnSubmitDisabled(true);
      const response = await resetActivate(passSalt, token, formData);
      setBtnSubmitDisabled(false);
      setResponseData(response);
      if (resSuccessful(response)) setModalOpen(true);
    } catch (error) {
      console.error(error);
    }
  }
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "350px",
      height: "160px",
      borderRadius: "8px",
      borderWidth: "1px",
      padding: "25px",
    },
  };
  return (
    <form className="space-y-3" onSubmit={handleSubmit}>
      <div className="flex-1 rounded-lg shadow-lg border bg-gray-50 px-6 pb-4 pt-8">
        <h1 className={`mb-3 text-2xl`}>Password Reset</h1>
        <div className="w-full">
          <div>
            <label
              className="mb-3 mt-5 block text-xs font-medium text-gray-900"
              htmlFor="password"
            >
              Password
            </label>
            <div className="relative">
              <input
                className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                id="password"
                type="password"
                name="password"
                placeholder="Enter your password"
                aria-describedby="password-error"
              />
              <KeyIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
            </div>
            <div id="email-error" aria-live="polite" aria-atomic="true"></div>
          </div>
          <div className="mt-4">
            <label
              className="mb-3 mt-5 block text-xs font-medium text-gray-900"
              htmlFor="confirm_password"
            >
              Confirm Password
            </label>
            <div className="relative">
              <input
                className="peer block w-full rounded-md border border-gray-200 py-[9px] pl-10 text-sm outline-2 placeholder:text-gray-500"
                id="confirm_password"
                type="password"
                name="confirm_password"
                placeholder="confirm password"
                aria-describedby="confirm-password-error"
              />
              <KeyIcon className="pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-500 peer-focus:text-gray-900" />
            </div>
            <div
              id="confirm-password-error"
              aria-live="polite"
              aria-atomic="true"
            ></div>
          </div>
        </div>
        <button
          className="mt-4 w-full flex h-10 items-center rounded-lg bg-blue-500 px-4 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
          type="submit"
          aria-disabled={btnSubmitDisabled}
        >
          Activate <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />
        </button>
        <div
          className="flex h-8 items-end space-x-1"
          aria-live="polite"
          aria-atomic="true"
        >
          {responseData?.message && (
            <>
              <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
              <p className="text-sm text-red-500">{responseData.message}</p>
            </>
          )}
        </div>
      </div>
      <Modal
        isOpen={modalOpen}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <h1 className="text-xl mt-3 text-center">Successful Reset!</h1>
        {/* <span className="mt-6">Now you can log in</span> */}
        <button
          className="mt-4 w-full h-10 rounded-lg bg-blue-500 px-4 text-sm font-medium text-white transition-colors hover:bg-blue-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500 active:bg-blue-600 aria-disabled:cursor-not-allowed aria-disabled:opacity-50"
          onClick={() => {
            navigate("/login");
          }}
        >
          Now to log in
        </button>
      </Modal>
    </form>
  );
}
